export default __webpack_public_path__ + "static/10-3c3c8ae3146ae36c209eb47936ac2e95.jpg";